import React from 'react'
import { injectIntl } from 'react-intl'

import Icon from '../../components/common/icon/Icon'
import CardsLayout from '../../components/common/cardsLayout/CardsLayout'
import Card from '../../components/common/card/Card'
import SingleLoader from '../../components/common/singleLoader/SingleLoader'

import MessageFeedback from '../../components/common/messageFeedback/MessageFeedback'

import AggregateReportBox from './AggregateReportBox'

const chartColor = {
  Axis: '#D5DADF',
  Purple: '#9D74DF',
  LightblueZero: '#00A6CF',
  LightblueZeroFill: '#cff1f9',
  LightblueOne: '#256A7C',
  LightblueTwo: '#1E9DBE',
  GialloDark: '#FFC31A',
  AcquamarineOne: '#39BA7C',
  AcquamarineOneFill: '#CFF8E4',
  AcquamarineTwoLight: '#98EDC9',
  AcquamarineTwo: '#8ACF61',
  AcquamarineThree: '#B0E2C9',
  Grey: '#DDDDDD',
  YellowTwo: '#FFD356',
  YellowThree: '#EEA236',
  LightblueThree: '#69CBE5',
  RedThree: '#FD7F75',
  DarkThree: '#CBCBCB',
  GreenTwo: '#8ACF61'

}

const AggregateReportData = ({ intl, data, loading, error, onReload }) => {
  const {
    Recipients,
    Delivered,
    Bounce,
    SuccessfulDeliveriesRate,
    Opens,
    TotalOpens,
    OpenRate,
    ClickRate,
    Clicks,
    TotalClicks,
    ClickToOpenRate,
    OpensWithoutImages,
    //
    Unsubscribed,
    UnsubscriptionRate,
    Abuse,
    AbuseRate,
    Share,
    ShareRate
  } = data
  const cardProps = {
    className: 'items-per-row-3'
  }

  const box1Props = {
    drawEmpty: loading,
    drawEmptyHeight: '200px',
    title: intl.formatNumber(SuccessfulDeliveriesRate / 100, { style: 'percent', maximumFractionDigits: 2 }),
    subtitle: intl.formatMessage({ id: 'Load.Statistics.PercDelivered' }),
    showGauge: true,
    gaugeValue: SuccessfulDeliveriesRate,
    gaugeColor: chartColor.GreenTwo,
    items: [{
      label: intl.formatMessage({ id: 'Load.MailupCommon.Recipients' }),
      value: intl.formatNumber(Recipients)
    }, {
      label: intl.formatMessage({ id: 'Load.Common.Delivered' }),
      value: intl.formatNumber(Delivered)
    }, {
      label: intl.formatMessage({ id: 'Load.MailupCommon.Bounce' }),
      value: intl.formatNumber(Bounce)
    }]
  }

  const box2Props = {
    drawEmpty: loading,
    drawEmptyHeight: '180px',
    title: intl.formatNumber(OpenRate / 100, { style: 'percent', maximumFractionDigits: 2 }),
    subtitle: intl.formatMessage({ id: 'Load.Statistics.PercOpens' }),
    showGauge: true,
    gaugeValue: OpenRate,
    gaugeColor: chartColor.AcquamarineOne,
    items: [{
      label: intl.formatMessage({ id: 'Load.MailupCommon.Open' }),
      value: intl.formatNumber(Opens)
    }, {
      label: (<><Icon family='sli' icon='next-1' className='frontend-p-right-xs-thin' />{intl.formatMessage({ id: 'Load.Statistics.OpeningsWithoutImages' })}</>),
      value: intl.formatNumber(OpensWithoutImages),
      tooltip: intl.formatMessage({ id: 'Load.Statistics.OpeningsWithoutImagesTooltip' })
    }, {
      label: intl.formatMessage({ id: 'Load.Common.TotalOpens' }),
      value: intl.formatNumber(TotalOpens)
    }]
  }

  const box3Props = {
    drawEmpty: loading,
    drawEmptyHeight: '180px',
    title: intl.formatNumber(ClickRate / 100, { style: 'percent', maximumFractionDigits: 2 }),
    subtitle: intl.formatMessage({ id: 'Load.Statistics.PercClicks' }),
    showGauge: true,
    gaugeValue: ClickRate,
    gaugeColor: chartColor.LightblueZero,
    items: [{
      label: intl.formatMessage({ id: 'Load.Common.Clicks' }),
      value: intl.formatNumber(Clicks)
    }, {
      label: intl.formatMessage({ id: 'Load.Common.TotalClicks' }),
      value: intl.formatNumber(TotalClicks)
    }, {
      label: intl.formatMessage({ id: 'Load.Statistics.PercClickOnOpen' }),
      value: intl.formatNumber(ClickToOpenRate / 100, { style: 'percent', maximumFractionDigits: 2 })
    }]

  }

  const box4Props = {
    drawEmpty: loading,
    drawEmptyHeight: '180px',
    title: intl.formatNumber(Unsubscribed),
    subtitle: intl.formatMessage({ id: 'Load.Common.Unsubscriptions' }),
    items: [{
      label: intl.formatMessage({ id: 'Load.Statistics.PercUnsub' }),
      value: intl.formatNumber(UnsubscriptionRate / 100, { style: 'percent', maximumFractionDigits: 2 })
    }]
  }

  const box5Props = {
    drawEmpty: loading,
    drawEmptyHeight: '90px',
    title: intl.formatNumber(Abuse),
    subtitle: intl.formatMessage({ id: 'Load.Statistics.AbuseReporting' }),
    items: [{
      label: intl.formatMessage({ id: 'Load.Statistics.ReportingRate' }),
      value: intl.formatNumber(AbuseRate / 100, { style: 'percent', maximumFractionDigits: 2 })
    }]
  }

  const box6Props = {
    drawEmpty: loading,
    drawEmptyHeight: '90px',
    title: intl.formatNumber(Share),
    subtitle: intl.formatMessage({ id: 'Load.Statistics.MsgShare' }),
    items: [{
      label: intl.formatMessage({ id: 'Load.Statistics.SharingsRate' }),
      value: intl.formatNumber(ShareRate / 100, { style: 'percent', maximumFractionDigits: 2 })
    }]
  }

  const loaderProps = {
    height: '465px'
  }

  const loaderContainerStyle = {
    position: 'relative'
  }
  const loadWrapperStyle = {
    position: 'absolute',
    left: '50%'
  }

  return (

    <div>
      {error &&
        <div className='frontend-box frontend-p-bottom'>
          <Icon family='fa' icon='exclamation-triangle' className='text-light' />&nbsp;
          <span>{intl.formatMessage({ id: 'Load.Common.LoadDataError' })}</span>
        </div>}
      {!error &&
        <section style={loaderContainerStyle}>
          {loading && <div style={loadWrapperStyle}><SingleLoader {...loaderProps} /></div>}
          <div className='frontend-row'>
            <CardsLayout>
              <Card {...cardProps}><AggregateReportBox {...box1Props} /></Card>
              <Card {...cardProps}><AggregateReportBox {...box2Props} /></Card>
              <Card {...cardProps}><AggregateReportBox {...box3Props} /></Card>
            </CardsLayout>
          </div>

          <div className='frontend-row'>
            <CardsLayout>
              <Card {...cardProps}><AggregateReportBox {...box4Props} /></Card>
              <Card {...cardProps}><AggregateReportBox {...box5Props} /></Card>
              <Card {...cardProps}><AggregateReportBox {...box6Props} /></Card>
            </CardsLayout>
          </div>
        </section>}
    </div>
  )
}

export default injectIntl(AggregateReportData)
